import Actions from './action';

export const welcomeInitState = {
	isOpportunityLoading: false,
	tokenSuccess: false,
	opportunityData: [],
	currentStatus: 2,
	tokenData: null,
	imageUrl: '',
	stepLabels: [
		{ title: 'Company Info', count: 1, pageIndex: 0, route: `/user/companyinfo/${localStorage.getItem('companyId')}`, disable: false },
		{ title: 'Contact Info', count: 2, pageIndex: 1, route: '/user/contactinfo/1', disable: false },
		{ title: 'Signature', count: 3, pageIndex: 3, route: '/user/signature/1', disable: false },
	]
};

const opportunityReducer = (state = welcomeInitState, action) => {
	switch (action.type) {
		case Actions.types.GET_OPPORTUNITY_DATA_START: {
			return {
				...state,
				isOpportunityLoading: true,
			};
		}
		case Actions.types.GET_TOKEN_START_SUCCESS: {
			return {
				...state,
				tokenSuccess: true,
				tokenData: action.res,
			};
		}
		case Actions.types.GET_OPPORTUNITY_DATA_SUCCESS: {
			console.log("SUCCESS", action.res.data)
			return {
				...state,
				isOpportunityLoading: false,
				opportunityData: action.res.data,
			};
		}
		case Actions.types.GET_OPPORTUNITY_DATA_ERROR: {
			return {
				...state,
				isOpportunityLoading: false,
			};
		}

		default:
			return state;
	}
};

export default opportunityReducer;
